import { type FC } from 'react'
import { type IInboxTreeCombine, type INodeModel } from 'entities/Inbox'
import styles from './styles.module.scss'

type IMenuPlaceholderTreeProps = {
  node: INodeModel<IInboxTreeCombine>
  depth: number
}

export const MenuPlaceholderTree: FC<IMenuPlaceholderTreeProps> = (props) => {
  const left = props.depth * 24
  return <div className={styles.wrap} style={{ left }}></div>
}
